import React from 'react';
import styled, { css } from 'styled-components';
import {device} from '../../styles/template';
import {TestingAnswers, TestingQuestion} from '../features/testing/TestingForm/styles'

interface Props {
    children?: React.ReactNode;
    col: string;
    gap: string;
    gapDesktop?: string;
    margin?: string;
    colDesktop?: string;
    id?: string;
    className?: string;
    centeredContent?: boolean;
    centeredContentMobileOnly?: boolean;
    centeredText?: boolean;
    autoWidth?: boolean;
    dangerouslySetInnerHTML?: { __html: string };
    centeredVertical?: boolean;
}

const Wrap = styled.div<Props>`
    display: grid;
    //align-items: start;
    width: 100%;
    grid-template-columns: repeat(${({ col }) => col}, minmax(0, 1fr));
    grid-template-rows: auto;
    gap: ${({ gap }) => gap}rem;
    //place-items: center;
    padding: ${({ margin }) => margin}rem 0;
    
    ${({ centeredContent }) => centeredContent && css`
        justify-items: center;
    `}

    ${({ centeredVertical }) => centeredVertical && css`
        align-items: center;
    `}


    ${({ centeredContentMobileOnly }) => centeredContentMobileOnly && css`
        justify-items: center;

        @media ${device.tablet} {
            justify-items: normal;
        }
    `}

    ${({ centeredText }) => centeredText && css`
        text-align: center;
    `} 
    
    ${({ autoWidth }) => autoWidth && css`
      grid-template-columns: auto auto;
    `}
    
    ${({ className }) => className  === 'illustrative' && css`
        @media ${device.tablet} {
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: auto;
            grid-template-areas:
            "head head"
            "aside img";
            align-items: center;

          ${TestingQuestion} {
            grid-area: head;
          }
          
          ${TestingAnswers} {
            grid-area: aside;
          }
        }
    `}
    
    @media ${device.tablet} { 
      grid-template-columns: repeat(${({ colDesktop }) => colDesktop}, minmax(0, 1fr));
      gap: ${({ gapDesktop }) => gapDesktop}rem;
    }
`;

const Grid: React.FC<Props> = props => {
    const { children, ...restProps } = props;
    return <Wrap {...restProps}>{children}</Wrap>
}

export default Grid